import { Component } from '@angular/core';
import { LnConeSvgIconComponent } from '@components/svg-icons/ln-cone-svg-icon/ln-cone-svg-icon.component';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'ln-empty-search-card',
  imports: [LnConeSvgIconComponent, TranslocoPipe],
  templateUrl: './ln-empty-search-card.component.html',
  styleUrl: './ln-empty-search-card.component.css',
})
export class LnEmptySearchCardComponent {}
